// Shared palette for quote statuses. Two shades per status:
//   CARD    → muted background + border for the whole card (SlicerQuotes columns)
//   BAR     → saturated accent for a narrow status bar / indicator (GroupCard)
// Kept here so the two palettes can't drift when a new status is added.

export const QUOTE_STATUS_CARD_COLORS = Object.freeze({
  CREATED: 'bg-slate-100 border-slate-300',
  SLICED: 'bg-amber-100 border-amber-300',
  BUILT: 'bg-lime-100 border-lime-300',
  SUBMITTED: 'bg-blue-100 border-blue-300',
  INTERACTING: 'bg-purple-100 border-purple-300',
  DEAL: 'bg-green-100 border-green-300',
  PENDING_PAYMENT: 'bg-yellow-100 border-yellow-300',
  PAID: 'bg-emerald-100 border-emerald-300',
  ONGOING: 'bg-indigo-100 border-indigo-300',
  INSPECTION: 'bg-orange-100 border-orange-300',
  READY: 'bg-teal-100 border-teal-300',
  DELIVERING: 'bg-cyan-100 border-cyan-300',
  DONE: 'bg-green-200 border-green-400',
  ON_HOLD: 'bg-red-100 border-red-300',
  CANCELLED: 'bg-gray-200 border-gray-400',
  DEFAULT: 'bg-gray-100 border-gray-300',
});

export const QUOTE_STATUS_BAR_COLORS = Object.freeze({
  CREATED: 'bg-slate-400',
  SLICED: 'bg-amber-400',
  BUILT: 'bg-lime-400',
  SUBMITTED: 'bg-blue-400',
  PENDING_PAYMENT: 'bg-yellow-400',
  PAID: 'bg-emerald-400',
  ONGOING: 'bg-indigo-400',
  INSPECTION: 'bg-orange-400',
  READY: 'bg-teal-400',
  DELIVERING: 'bg-cyan-400',
  DONE: 'bg-green-500',
  ON_HOLD: 'bg-red-400',
  CANCELLED: 'bg-gray-400',
  DEFAULT: 'bg-gray-300',
});
